export default {
    alerts: {
        active: 'Active',
        edit: 'Edit Alert',
        inactive: 'Inactive',
        menu: {
            create: 'New',
            index: 'Alerts',
            list: 'Alerts'
        },
        table_titles: {
            bg_color: 'BG Color',
            created_at: 'Created at',
            display_on_landing: 'Display on landing',
            display_on_login: 'Display on sign-in',
            display_on_home: 'Display on home',
            expired_at: 'Expired at',
            id: 'ID',
            priority: 'Priority',
            published_at: 'Published at',
            setting: 'Edit | Delete',
            state: 'State',
            title: 'Title'
        },
        title_hint: 'This title just used to manage alerts',
        yes: 'Yes',
        no: 'No',
    }
}

